import { Navigate, useParams } from 'react-router-dom';
import { LayoutPageTitle, LayoutBreadcrumbs } from '@/features/layout';
import { useGetWorksheetQuery } from '@/state/slices/reports';
import { WorksheetEditor } from '@/features/template-manager';

export default function WorksheetEditorPage() {
  const { uuid } = useParams<{ uuid: string }>();
  const { data: worksheet } = useGetWorksheetQuery(uuid ?? '', {
    skip: !uuid,
  });

  if (!uuid) return <Navigate to="/templates/worksheets" replace />;

  return (
    <>
      <LayoutPageTitle title="Edit Worksheet" />
      <LayoutBreadcrumbs
        items={[
          { label: 'Templates', to: '/templates/worksheets' },
          { label: worksheet?.name ?? 'Loading...' },
        ]}
      />
      <WorksheetEditor uuid={uuid} />
    </>
  );
}
